import SettingsPane from './SettingsPane';

export default SettingsPane;
export { SettingsPane };
